import React, {useEffect, useState} from 'react';
import {Tarefa} from "../../models/Tarefa";
import fb from "../../lib/firebase";
import {AppUser} from "../../models/app";
import {IonList, IonProgressBar, IonRefresher, IonRefresherContent} from "@ionic/react";
import TarefaCard from "./TarefaCard";
import {RefresherEventDetail} from "@ionic/core";
import AgendaFiltros, {
  aplicarFiltrosAgenda,
  buildQueryStringFromAgendaFiltros,
  IAgendaFiltros
} from "./AgendaFiltros";
import {useHistory} from "react-router";

interface AgendaAnterioresProps {
  user: AppUser;
  filtros: IAgendaFiltros;
  setFiltros: (filtros: IAgendaFiltros) => void;
}

const AgendaAnteriores: React.FC<AgendaAnterioresProps> = (props) => {
  const {user, filtros} = props;
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [colecao, setColecao] = useState<Tarefa[]>([]);
  const [colecaoFiltrada, setColecaoFiltrada] = useState<Tarefa[]>([]);

  // listeners
  useEffect(() => {
    setLoading(true);
    const query = fb.db.collection('agenda')
      .where('owner', '==', user.uid)
      .where('concluido', '==', true)
      .orderBy('data', 'desc');
    return query.onSnapshot(snap => {
      const _colecao = fb.col(snap);
      setLoading(false);
      setColecao(_colecao);
    });
  }, [user.uid]);

  // update colecao filtrada
  useEffect(() => {
    // console.log('reset filtrada');
    setColecaoFiltrada(aplicarFiltrosAgenda(colecao, filtros, 'passado', true));
  }, [filtros, colecao]);

  const doRefresh = (event: CustomEvent<RefresherEventDetail>) => {
    event.detail.complete();
  };

  const onChangeFiltros = (_filtros: IAgendaFiltros) => {
    const query = buildQueryStringFromAgendaFiltros(_filtros, {tab: 'passados'});
    history.push(`/agenda?${query}`);
  }

  return (
    <>
      {loading &&
        <IonProgressBar type="indeterminate"/>
      }
      {!loading &&
        <>
          <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
            <IonRefresherContent/>
          </IonRefresher>

          <AgendaFiltros
            className="mb-2 mt-2"
            onChange={onChangeFiltros}
            filtros={filtros}
          />

          <IonList>
            {colecaoFiltrada.map(tarefa => (
              <TarefaCard
                tarefa={tarefa}
                key={tarefa.id}
              />
            ))}
          </IonList>

          {!colecaoFiltrada.length &&
            <div className="italic opacity-75 text-center mt-8 px-8">
              Nenhum registro encontrado com os filtros indicados.
            </div>
          }
        </>
      }
    </>
  );
}

export default AgendaAnteriores;
